import { EnterMFA } from './EnterMFA';
import { Hello } from './Hello';
import { NotFound } from './NotFound';
import { SelectMFA } from './SelectMFA';

export const LoginPages = { Hello, NotFound, SelectMFA, EnterMFA };
